import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { ITeleopJoystickConfiguration } from "@formant/core/model/ITeleopJoystickConfiguration";
import { Icon } from "@formant/ui/component/common/Icon";

import { operateStore } from "../../../stores";
import * as styles from "./GamepadIndicator.scss";

export interface IGamepadIndicatorProps {
    configuration?: ITeleopJoystickConfiguration;
}

@observer
export class GamepadIndicator extends Component<IGamepadIndicatorProps> {
    public render() {
        const { gamepad } = operateStore;
        const { configuration } = this.props;
        const gamepadId = gamepad?.id;
        const gamepadDisabled =
            configuration?.disableGamepadAndKeyboard ?? false;
        const tooltip = gamepadDisabled
            ? "Gamepad is currently disabled."
            : gamepadId
              ? `Gamepad detected: ${gamepadId}`
              : undefined;
        return (
            <Icon
                name="gamepad"
                className={classnames(
                    styles["gamepad-indicator"],
                    !!gamepad && styles.connected,
                )}
                data-tooltip={tooltip}
            />
        );
    }
}
